<template>
  <div class="becomeOwner">
    <div class="beforAdd">
      <div class="beforAddSwiper">
        <swiper :options="swiperOption">
          <swiper-slide><img class="banner" src="@/assets/images/becomeOwner/1.png"></swiper-slide>
          <swiper-slide><img class="banner" src="@/assets/images/becomeOwner/2.png"></swiper-slide>
          <swiper-slide><img class="banner" src="@/assets/images/becomeOwner/3.png"></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="addBtnBox"><div class="addBtn" @click="goaddcar()">我要发布车辆</div></div>

    </div>
  </div>
</template>

<script>
  /*组件方式引用*/
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { deviceType } from '@/utils/env'


  import { apply } from '@/utils/api';
  export default {
    name: 'becomeOwner',
    components: {swiper, swiperSlide},
    data() {
      return {
        swiperOption: { // swiper3 组件
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: { delay: 3000 },
          speed: 600,
          loop: true,
        }
      }
    },
    watch: {},
    created () {
      
    },
    mounted(){
    
      (function(){
        // var height = document.scrollingElement.scrollHeight
        // var number = 0;  //控制结束累加器
        // var length = 0;  //控制每次翻滚长度
        // var frequency = 120;    //控制总时间
        // var time = setInterval(function(){
        //     number += 1;
        //     if(number == frequency + 1){
        //         clearInterval(time);
        //     } else {
        //         length += height / frequency;
        //          document.scrollingElement.scrollTop= length;
        //         // 
        //     }
        // },100);        //每隔1S翻滚

        setTimeout(function(){
          document.scrollingElement.scrollTop = document.scrollingElement.scrollHeight;
        },2000)

      })()

      // this.flexible.showToast({
      //             content: deviceType
      //           });
    },
    methods: {
      goaddcar(){
        this.$router.push({ path: "/addcar" });
      }
    }
  }
</script>
<!-- swiper-pagination-bullet swiper-pagination-bullet-active -->
<style lang="scss">
  .becomeOwner .beforAdd .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 230px;
    height: 20px;
    text-align: center;
  }
  .beforAdd .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    width: 16px;
    height: 16px;
    background-color: #fff;
    opacity: 0.5;
    border-radius: 8px;
  }
  .beforAdd .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet-active {
    width: 36px;
    opacity: 1;
  }
</style>
<style lang="scss" scoped>
.becomeOwner {
  width: 100%;
  // height: 100%;
  // position: fixed;
  // top: 0;
  // left: 0;
  overflow-y: auto;
  img {
    width: 100%;
    // height:100vh;
  }
  .samllHeader {
    width: 100%;
    height: 110px;
    line-height: 110px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #fff;
    .backIcon {
      display: block;
      width: 40px;
      height: 40px;
      position: absolute;
      top: 35px;
      left: 35px;
      background-image: url("~@/assets/images/backIcon.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    .titleName {
      width: 100%;
      font-size: 32px;
      text-align: center;
      font-weight: normal;
    }
  }
  .beforAdd {
    width: 100%;
    height: 100%;
    position: relative;
    .beforAddSwiper {
      position: relative;
      z-index: 1;
      img{
        // transform:scale(0.9);
      }
    }
    .addBtnBox {
      width: 100%;
      height: 90px;
      position: absolute;
      bottom: 94px;
      left: 0;
      z-index: 10;
      .addBtn {
        width: 600px;
        height: 90px;
        line-height: 90px;
        margin: 0 auto;
        font-size: 32px;
        color: #fff;
        text-align: center;
        background-color: #FF8307;
        border-radius: 45px;
      }
    }
  }
}
</style>